import { combineReducers, createStore } from 'redux'
import miusuario from '../redux/reducers/miusuario'

const reducer = combineReducers({
    miusuario
})

const store = createStore(reducer)

export default store